export default __webpack_public_path__ + "static/media/B1_21.fe25fa76.mp3";